import { useEffect, useState } from "react";
import { History, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { StatusBadge } from "@/components/Common";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

function historyTime(value) {
  if (!value) {
    return "—";
  }
  return new Intl.DateTimeFormat("id-ID", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function QueueHistoryDialog({ route }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    setItems(null);
    api.get(`/keeper/routes/${route.id}/history`)
      .then((response) => setItems(response.data.items))
      .catch((error) => {
        toast.error(errMsg(error));
        setItems([]);
      });
  }, [open, route.id]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button
        type="button"
        variant="outline"
        className="mt-4 w-full border-[#1A3323]/20"
        onClick={() => setOpen(true)}
        data-testid={`open-route-history-${route.code}`}
      >
        <History className="mr-2 h-4 w-4" />
        Lihat Riwayat Antrian
      </Button>
      <DialogContent className="max-w-lg" data-testid={`route-history-dialog-${route.code}`}>
        <DialogHeader>
          <DialogTitle>Riwayat Antrian · {route.name}</DialogTitle>
          <DialogDescription>
            Tiket yang sudah selesai, dilewati, atau dibatalkan pada jalur ini.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-80 space-y-2 overflow-y-auto" data-testid={`route-history-list-${route.code}`}>
          {items === null && (
            <div className="flex items-center justify-center py-8 text-sm text-muted-foreground">
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Memuat riwayat...
            </div>
          )}
          {items?.length === 0 && (
            <p className="py-8 text-center text-sm text-muted-foreground">
              Belum ada riwayat antrian pada jalur ini.
            </p>
          )}
          {items?.map((ticket) => (
            <div
              key={ticket.id}
              className="flex items-center justify-between gap-3 rounded-lg bg-[#F5F3EB] p-3"
              data-testid={`route-history-ticket-${ticket.id}`}
            >
              <div className="min-w-0">
                <p className="font-mono text-lg font-extrabold text-[#1A3323]">#{ticket.number}</p>
                <p className="truncate text-sm font-semibold text-[#1A3323]">{ticket.display_name}</p>
              </div>
              <div className="shrink-0 text-right">
                <StatusBadge status={ticket.status} testid={`route-history-status-${ticket.id}`} />
                <p className="mt-1 text-xs text-muted-foreground">
                  {historyTime(ticket.completed_at || ticket.skipped_at || ticket.created_at)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}